<!--
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-07-06 15:03:01
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-07-06 15:23:07
 * @FilePath: \xm-runing-main\src\components\xm-tenant-and-industry-toggle\components\xm-tenant-select.vue
* @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang="ts">
import {
  Select as ASelect
} from 'ant-design-vue'

import { useXmTenantSelectStore } from '../stores/xm-tenant-select';

const XmTenantSelectStore = useXmTenantSelectStore()

const {
  isMultiple,
  selectProps
} = storeToRefs(XmTenantSelectStore)

const {
  onChange
} = XmTenantSelectStore
</script>

<template>
  <ASelect v-if="isMultiple" v-bind="selectProps" @change="onChange" />
</template>
